import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { PricesService } from '../../_services/prices.service';
import { RegionService } from '../../_services/region.service';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-add-plan',
  templateUrl: './add-plan.component.html',
  styleUrls: ['./add-plan.component.css']
})
export class AddPlanComponent implements OnInit {

  addPromoCodeForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;

  more_value: 0;
  regionList: any[] = [];

  userId: '';
  id = this.route.snapshot.params.id;

  // tslint:disable-next-line:max-line-length
  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private pricesService: PricesService, private spinnerService: Ng4LoadingSpinnerService, private regionService: RegionService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }

    // tslint:disable-next-line:triple-equals
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.getRegions();

    this.userId = this.userdetaild['_id'];

    if(this.id){
      this.getPlanById(this.id);
    }


    this.addPromoCodeForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      kind: ['', [Validators.required]],
      type: ['', [Validators.required]],
      code: ['', [Validators.required, Validators.maxLength(6)]],
      region: ['', [Validators.required]],
      description: ['', [Validators.required]],
      price: ['', [Validators.required, Validators.min(0)]],
      discount: ['', [Validators.required, Validators.min(0)]],
      unitsession: ['', [Validators.required,  Validators.min(0)]],
      unitboat: ['', [Validators.required,  Validators.min(0)]],
      subscriptionsession: ['', [Validators.required,  Validators.min(0)]],
      subscriptionboat: ['', [Validators.required,  Validators.min(0)]],
      time: ['', [Validators.required,  Validators.min(0)]],
      is_tax_inclusive: ['', [Validators.required]]
    });



    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

  }

  get f() { return this.addPromoCodeForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    // stop here if form is invalid
    if (this.addPromoCodeForm.invalid) {
      this.spinnerService.hide();
      return;
    }
    let units = {
      session: (this.addPromoCodeForm.controls.unitsession.value)?this.addPromoCodeForm.controls.unitsession.value:0,
      boat: (this.addPromoCodeForm.controls.unitboat.value)?this.addPromoCodeForm.controls.unitboat.value:0,
    }
    let subscription = {
      session: (this.addPromoCodeForm.controls.subscriptionsession.value)?this.addPromoCodeForm.controls.subscriptionsession.value:0,
      boat: (this.addPromoCodeForm.controls.subscriptionboat.value)?this.addPromoCodeForm.controls.subscriptionboat.value:0,
    }
    const addPayload = {
      name: this.addPromoCodeForm.controls.name.value,
      type: this.addPromoCodeForm.controls.type.value,
      kind: this.addPromoCodeForm.controls.kind.value,
      code: this.addPromoCodeForm.controls.code.value.toUpperCase(),
      region: this.addPromoCodeForm.controls.region.value,
      price: this.addPromoCodeForm.controls.price.value,
      units: units,
      subscription: subscription,
      description: (this.addPromoCodeForm.controls.description.value) ? this.addPromoCodeForm.controls.description.value : '',
      discount: (this.addPromoCodeForm.controls.discount.value) ? this.addPromoCodeForm.controls.discount.value : 0,
      time: (this.addPromoCodeForm.controls.time.value) ? this.addPromoCodeForm.controls.time.value : 0,
      is_tax_inclusive: this.addPromoCodeForm.controls.is_tax_inclusive.value,
      userid: this.userId
    };

    if(this.id){
      this.editPlan(this.id,addPayload);
    }
    else{
      this.addPlan(addPayload);
    }
        

  }




  addPlan(payload) {
    this.pricesService.addPlan(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.spinnerService.hide();
            this.router.navigate(['/plan-list']);
          } else {
            this.spinnerService.hide();
            this.toaster.showError('Add Plan', data.ResponseMessage);
          }
        },
        error => {
          this.spinnerService.hide();
          this.toaster.showError('Add Plan', error);
        });
  }

  editPlan(id, payload) {
    this.pricesService.updatePlan(id,payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.spinnerService.hide();
            this.router.navigate(['/plan-list']);
          } else {
            this.spinnerService.hide();
            this.toaster.showError('Add Plan', data.ResponseMessage);
          }
        },
        error => {
          this.spinnerService.hide();
          this.toaster.showError('Add Plan', error);
        });
  }

  getRegions() {
    this.regionService.getRegions()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.regionList = data.Data;
          } 
        },
        error => {
          console.log('Region', error);
        });
  }


  getPlanById(id) {
    this.pricesService.getPlanById(id)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            let datas = data.Data;
            this.addPromoCodeForm.setValue({
              name: datas.name,
              type: datas.type,
              kind: (datas.kind)?datas.kind:'',
              code: datas.code,
              region: datas.region,
              price: datas.price,
              unitsession: datas.units.session,
              unitboat: datas.units.boat,
              subscriptionsession: datas.subscription.session,
              subscriptionboat: datas.subscription.boat,
              description: datas.description,
              discount: datas.discount,
              time: datas.time,
              is_tax_inclusive: datas.is_tax_inclusive,
            });
          } 
        },
        error => {
          console.log('Region', error);
        });
  }

}
